<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        添加优惠券
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">添加优惠券</div>
      </div>
      <div class="table">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          style="padding-top:30px; margin: 0 auto;width: 532.6px;"
        >
        
          <el-form-item label="优惠券名称:">
            <el-input v-model="name" style="width:280px"></el-input>
          </el-form-item>
          <el-form-item label="发放数量:">
            <el-input v-model="number" style="width:280px" placeholder="只能输入正整数,输入0或不输入默认不限量"></el-input>
          </el-form-item>
          <el-form-item label="面额:">
            <el-input v-model="money" style="width:280px"></el-input>
            <div class="items">元</div>
            <div style="font-size:12px;color:rgba(102,102,102,1);">面值只能是数值,0.01-10000,限2位小数</div>
          </el-form-item>
          <el-form-item label="每人限领:">
            <el-input v-model="max" style="width:280px"></el-input>
            <div class="items">张</div>
          </el-form-item>
          <el-form-item label="使用门槛:">
            <template>
              <el-checkbox v-model="checked" true-label="0" false-label = "1" @change="checked1($event)" :disabled = "threshold">无门槛</el-checkbox>

              <span>  满 </span>
              <el-input :disabled="threshold1"      style="width:80px" v-model="sill"></el-input>
              <span> 元可使用 </span>
            </template>
          </el-form-item>
          <el-form-item label="有效期 :">
            <template>
              <div>
                <el-radio v-model="radio" label="1" @change="create($event)">日期范围</el-radio>

                
                <template>
                  <el-date-picker
                    style="width:140px"
                    v-model="begain_date"
                    placeholder="开始时间"
                    type="date"
                    value-format="timestamp"
                    :disabled = "dab1"
                  ></el-date-picker>
                </template>
                <span> 至 </span>
                <template>
                  <el-date-picker
                    style="width:140px"
                    v-model="end_date"
                    type="date"
                    placeholder="结束时间"
                    value-format="timestamp"
                    :disabled = "dab2"
                  ></el-date-picker>
                </template>
              </div>
              <div style="margin-top:20px">
                <el-radio v-model="radio" @change="create($event)" label="2">固定天数</el-radio>
                <el-input style="width:214px" :disabled = "dab3" v-model="day"></el-input>
                <div class="item">天</div>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="可使用商品:">
            <template>
              <el-radio-group v-model="radio2">
                <el-radio v-model="is_sell" :label="0" @change="all($event)">全场通用</el-radio>
                <el-radio v-model="is_sell" :label="2" @change="all($event)">指定商品</el-radio>
                <el-radio v-model="is_sell" :label="1" @change="all($event)">指定分类</el-radio>
                <el-radio v-model="is_sell" @change="all($event)" :label="3">指定品牌</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <!-- 指定商品 -->
          <transition name="fade">
            <div v-show="show1">
             
              <el-form-item label="添加商品:">
                <el-input
                  suffix-icon="el-icon-search"
                  style="width:200px"
                  v-model="input21"
                  @blur="addSeek"
                  placeholder="请输入商品名或货号"
                ></el-input>
                <template>
                  <el-select
                    @change="opt($event)"
                    v-model="value"
                    placeholder="请选择"
                    style="width:200px;margin-left:10px;"
                  >
                    <el-option
                      suffix-icon="el-icon-plus"
                      v-for="item in options"
                      :key="item.value"
                      :label="item.title"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item>
                <div>
                  购买以下商品可使用优惠券抵扣金额,已选中
                  <span style="color:#F64E62">{{tableData_num}}</span> 件商品
                </div>

                <el-table
                  :data="selectedData"
                  border
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  style="width: 100%; line-height:0"
                >
                  <el-table-column
                    show-overflow-tooltip
                    align="center"
                    prop="title"
                    label="商品名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column align="center" prop="item_no" label="货号"></el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <button class="button1" @click="del_selectedData(scope.row.id)">删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pager">
                  <el-row style="text-align:center">
                    <!--   -->
                    <el-col>
                      <el-pagination
                        @current-change="setPage"
                        :pager-count="5"
                        background
                        layout="prev, pager, next"
                        :total="tableData_num"
                        :page-size="5"
                      ></el-pagination>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </div>
          </transition>
          <!-- 指定分类 -->
          <transition name="fade">
            <div v-show="show2">
              
              <el-form-item label="添加分类:">
                <el-input
                  suffix-icon="el-icon-search"
                  style="width:200px"
                  v-model="input22"
                  @blur="addSeek"
                  placeholder="请输入分类名"
                ></el-input>
                <template>
                  <el-select
                    @change="opt1($event)"
                    v-model="value1"
                    placeholder="请选择"
                    style="width:200px;margin-left:10px;"
                  >
                    <el-option
                      suffix-icon="el-icon-plus"
                      v-for="item in options1"
                      :key="item.value"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item>
                <div>
                  购买以下指定分类可使用优惠券抵扣金额,已选中
                  <span style="color:#F64E62">{{tableData1_num}}</span> 类
                </div>

                <el-table
                  :data="selectedData1"
                  border
                  :header-cell-style="{
                    'background' : 'rgba(245,250,249,1)'
                  }"
                  style="width: 100%; line-height:0"
                >
                  <el-table-column
                    show-overflow-tooltip
                    align="center"
                    prop="title"
                    label="商品分类"
                    width="200"
                  ></el-table-column>

                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <button class="button1" @click="del_selectedData1(scope.row.title)">删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pager">
                  <el-row style="text-align:center">
                    <!--   -->
                    <el-col>
                      <el-pagination
                        @current-change="setPage1"
                        :pager-count="5"
                        background
                        layout="prev, pager, next"
                        :total="tableData1_num"
                        :page-size="5"
                      ></el-pagination>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </div>
          </transition>
          <!-- 指定品牌 -->
          <transition name="fade">
            <div v-show="show3">
            
              <el-form-item label="添加商品:">
                <el-input
                  suffix-icon="el-icon-search"
                  style="width:200px"
                  v-model="input23"
                  @blur="addSeek"
                  placeholder="请输入商品名或货号"
                ></el-input>
                <template>
                  <el-select
                    @change="opt2($event)"
                    v-model="value2"
                    placeholder="请选择"
                    style="width:200px;margin-left:10px;"
                  >
                    <el-option
                      suffix-icon="el-icon-plus"
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item>
                <div>
                  购买以下指定品牌可使用优惠券抵扣金额,已选中
                  <span style="color:#F64E62">{{tableData2_num}}</span> 个品牌
                </div>

                <el-table
                  :data="selectedData2"
                  border
                  :header-cell-style="{
                    'background' : 'rgba(245,250,249,1)'
                  }"
                  style="width: 100%; line-height:0"
                >
                  <el-table-column
                    align="center"
                    prop="name"
                    label="品牌名称"
                    width="200"
                    show-overflow-tooltip
                  ></el-table-column>

                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <button class="button1" @click="del_selectedData2(scope.row.id)">删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pager">
                  <el-row style="text-align:center">
                    <el-col>
                      <el-pagination
                        @current-change="setPage2"
                        :pager-count="5"
                        background
                        layout="prev, pager, next"
                        :total="tableData2_num"
                        :page-size="5"
                      ></el-pagination>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </div>
          </transition>
          <!--  -->
          <el-form-item label="备注:">
            <textarea name id="tetx" v-model="remark" placeholder="请输入内容"></textarea>
          </el-form-item>

          <el-form-item >
            <el-button type="success" @click="submit()" style="margin-left:100px">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

            serve: this.$store.state.serve,
      threshold: false,
      threshold1: false,
      dab1 : false,
      dab2 : false,
      dab3 : false,
      show1: false,
      show2: false,
      show3: false,
      labelPosition: "right",
      radio2: 0,
      checked: false,
      radio: "1",
      money: 0,

      tableData: [],
      selectedData: [],
      tableData_num: 0,

      tableData1: [],
      selectedData1: [],
      tableData1_num: 0,

      tableData2: [],
      tableData2_num: 0,
      selectedData2: [],

      options: [],
      options1: [],
      options2: [],
      value: "",
      value1: "",
      value2: "",
      token: "",
      username: "",
      type1: "",

      name: "",
      number: "",
      money: "",
      max: "",
      sill: "",
      begain_date: "",
      end_date: "",
      day: "",
      remark: "",
      is_sell: "",
      input21: "",
      input22: "",
      input23: "",
      v_id: "",
      page: 1,
      page1: 1,
      page2: 1,
      period: '',//有效期
    };
  },
  created() {
    this.$store.state.leftTitle = "优惠券表";
    this.$store.state.topActiveId = 5;
    this.username = this.$cookies.get("username");
    this.token = this.$cookies.get("token");
    
  },
  methods: {
    del_selectedData(id) {
      //删除指定商品
      var tempArr = _.filter(this.tableData, function(o) {
        return o.id != id;
      });
      this.tableData = tempArr;
      var temp_arr = [];
      var p = this.page - 1;
      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData[i]) {
          temp_arr.push(this.tableData[i]);
        }
      }
      this.selectedData = temp_arr;
      this.tableData_num = this.tableData.length;
      if (temp_arr.length == 0) {
        this.setPage(this.page - 1)
      }
    },
    del_selectedData1(id) {
      //删除指定分类
      var tempArr = _.filter(this.tableData1, function(o) {
        return o.title != id;
      });
      this.tableData1 = tempArr;
      var temp_arr = [];
      var p = this.page1 - 1;
      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData1[i]) {
          temp_arr.push(this.tableData1[i]);
        }
      }
      this.selectedData1 = temp_arr;
      this.tableData1_num = this.tableData1.length;

      if (temp_arr.length == 0) {
        this.setPage1(this.page1 - 1);
      }
    },
    del_selectedData2(id) {
      var tempArr = _.filter(this.tableData2, function(k) {
        return k.id != id;
      });

      this.tableData2 = tempArr;

      var temp_arr = [];
      var p = this.page2 - 1;
      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData2[i]) {
          temp_arr.push(this.tableData2[i]);
        }
      }
      this.selectedData2 = temp_arr;
      this.tableData2_num = this.tableData2.length;
      if (temp_arr.length == 0) {
        this.setPage2(this.page2 - 1);
      }
    },
    setPage(v) {
      //指定商品分页
      this.page = v;
      var temp_arr = [];
      var p = v - 1;

      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData[i]) {
          temp_arr.push(this.tableData[i]);
        }
      }
      this.selectedData = temp_arr;
    },
    setPage1(v) {
      this.page1 = v;
      var temp_arr = [];
      var p = v - 1;
      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData1[i]) {
          temp_arr.push(this.tableData1[i]);
        }
      }
      this.selectedData1 = temp_arr;
    },
    setPage2(v) {
      this.page2 = v;
      var temp_arr = [];
      var p = v - 1;
      for (var i = p * 5; i <= p * 5 + 4; i++) {
        if (this.tableData2[i]) {
          temp_arr.push(this.tableData2[i]);
        }
      }
      this.selectedData2 = temp_arr;
    },
    opt(v) {
      //指定商品下拉框选中触发

      this.axios
        .get(this.serve+"/admin/add_coupons_product", {
          params: {
            username: this.username,
            token: this.token,
            product_id: v
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.tableData.push(res.data.data);
            this.tableData_num = this.tableData.length;
            if (this.tableData_num <= 5) {
              this.selectedData.push(res.data.data);
            }
          }
        });
    },
    opt1(v) {
      //指定分类下拉框选中
      this.tableData1.push({
        title: v
      });
      this.tableData1_num = this.tableData1.length;
      if (this.tableData1_num <= 5) {
        this.selectedData1.push({
          title: v
        });
      }
    },
    opt2(v) {
      this.axios.get(this.serve+'/admin/add_coupons_brand',{
        params:{
          username : this.username,
          token : this.token,
          id : v
        }
      }).then(res=>{
        var json = res.data.data;
        if(res.data.status == 'success'){
          this.tableData2.push(json)
          this.tableData2_num = this.tableData2.length;
           if (this.tableData2_num <= 5) {
            this.selectedData2.push(json);
          }
        }
      })
    },
    addSeek() {
      //搜索里面的input 失去焦点触发
      if (this.v_id == 2) {
        //指定商品搜索
        this.axios
          .get(this.serve+"/admin/coupons_product_search", {
            params: {
              username: this.username,
              token: this.token,
              key: this.input21
            }
          })
          .then(res => {
            var json = res.data.data;
            this.options = [];
            if (res.data.status == "success") {
              for (var key in json) {
                this.options.push(json[key]);
              }
            }
          });
      }
      if (this.v_id == 1) {
        //指定分类搜索
        this.axios
          .get(this.serve+"/admin/coupons_category_search", {
            params: {
              username: this.username,
              token: this.token,
              key: this.input22
            }
          })
          .then(res => {
            var json = res.data.data;
            this.options1 = [];
            if (res.data.status == "success") {
              for (var key in json) {
                this.options1.push(json[key]);
              }
            }
          });
      }
      if (this.v_id == 3) {
        //指定品牌搜索

        this.axios
          .get(this.serve+"/admin/coupons_brand_search", {
            params: {
              username: this.username,
              token: this.token,
              key: this.input23
            }
          })
          .then(res => {
            this.options2 = [];
            var json = res.data.data;
            for (var key in json) {
              this.options2.push(json[key]);
            }
          });
      }
    },
    all(v) {
      
      this.v_id = v;
      this.type1  =  v 
      if (v == 0) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
      }
      if (v == 2) {
        this.show1 = true;
        this.show2 = false;
        this.show3 = false;
      }
      if (v == 1) {
        this.show1 = false;
        this.show2 = true;
        this.show3 = false;
      }
      if (v == 3) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = true;
      }
    },

    create(v) {
      //有效期
      this.period = v
      if(v == 1){
        this.dab3  = true;
        this.dab1 = false;
        this.dab2 = false;
      }
      if(v == 2){
        this.dab1 = true;
        this.dab2 = true;
        this.dab3 = false
      }
    },

    checked1(v) {
      //无门槛
      if(v == 0){
        this.threshold1 = true;
        this.sill = v;
      }else if(v == 1){
        this.sill = '';
        this.threshold1 = false
      }
    },
    submit() {
      // 类型 0-通用 1-分类 2-商品 3-品牌
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      
      if (this.sill !== "") {
        var edg = /^[0-9]*$/;
        if (!edg.test(this.sill)) {
          this.$message.error("使用门槛金额只能是数字");
          return;
        }
      }
      if (this.number !== "") {
        var edg = /^[0-9]*$/;
        if (!edg.test(this.number)) {
          this.$message.error("发放数量只能是数字");
          return;
        }
      }
      if (this.max !== "") {
        var edg = /^[0-9]*$/;
        if (!edg.test(this.max)) {
          this.$message.error("每人限领只能是数字");
          return;
        }
      }
      if (this.day !== "") {
        var edg = /^[0-9]*$/;
        if (!edg.test(this.day)) {
          this.$message.error("固定天数只能是数字");
          return;
        }
      }
      if (this.money !== "") {
        var edg = /^[0-9]*$/;
        if (!edg.test(this.money)) {
          this.$message.error("面额只能是数字");
          return;
        }
      }
     
      if(this.type1 == ''){
        this.type1 = '0'
      } 
      
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("name", this.name);
      formData.append("number", this.number);
      formData.append("money", this.money);
      formData.append("max", this.max);
      formData.append("sill", this.sill);
      if(this.period == '' || this.period == '1'){
        formData.append("begain_date", this.begain_date/1000);
        formData.append("end_date", this.end_date/1000);
      }
      if(this.period == '2'){
        formData.append("days", this.day);
      }
      formData.append("type", this.type1);
      formData.append("info", this.remark);
      if(this.type1 == '2'){
          var str = '';
          for(var key in this.tableData){
            str += this.tableData[key].id+';'
          }
          formData.append('product' , str)
      }
      if(this.type1 == '1'){
        var name = '';
        for(var key in this.tableData1){
          name += this.tableData1[key].title + ';'
        }
          formData.append("category", name);
      }
      if(this.type1 == '3'){
        var str_id = ''
        for(var key in this.tableData2){
          str_id += this.tableData2[key].id+';'
        }
        formData.append('brand', str_id)
      }
      // formData.append("product", this.product);
      // formData.append("brand", this.brand);
      this.axios
        .post(this.serve+"/admin/add_coupons", formData, config)
        .then(res => {
          if(res.data.status == 'success'){
            loading.close();
            this.$router.push({path:'./c_special'})
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } else if(res.data.status == 'error'){
            loading.close();
            alert('上传失败')
          }
        })
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  .fade-leave {
    opacity: 1;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .fade-leave-active {
    transition: opacity 0.2s;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-enter-active {
    transition: opacity 0.5s;
  }
  #tetx {
    width: 360px;
    height: 150px;
  }
  .audit_div {
    display: flex;
    align-items: center;
    height: 60px;
    .audit_div_icon {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      color: #c0c4cc;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      width: 190px;
      padding-left: 10px;

      cursor: pointer;
    }
    .audit_div_p1 {
      font-size: 14px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
    }

    .audit_div_p3 {
      margin-left: 4px;
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
    .audit_div_p3:hover {
      color: rgba(51, 51, 51, 1);
    }
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
    .items {
      width: 38px;
      height: 38px;
      text-align: center;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      position: absolute;
      top: 0;
      right: 130px;
    }
    .item {
      width: 38px;
      height: 38px;
      text-align: center;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      position: absolute;
      top: 60px;
      right: 86px;
    }

    .button1 {
      // border: 0;
      border: none;
      outline: none;
      background: none;
      font-size: 14px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
      cursor: pointer;
    }
    .button1:hover {
      color: #0099ff;
    }
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 110px;
    height: 36px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
